// Types
import HistoryTime from 'components/HistoryTime';
// Utils
import { getText } from 'i18n/intl';
import _ from 'lodash';
import { THistory, type TReservationMode } from '@timeedit/types/lib/types';
// Components
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

export interface PropertiesProps {
  data: TReservationMode;
  onChange: (key: string, value: any) => void;
}

const Properties = (props: PropertiesProps) => {
  const { data, onChange } = props;
  return (
    <TEDrawerSection label="Properties">
      <div className="wrapper-section">
        <div className="section-item">
          <TEInput.Switch
            label="Show in client"
            tooltip="Show in client"
            value={data.showInClient}
            onChange={(val) => onChange('showInClient', val)}
            data-testid="show-in-client"
          />
          <TEInput.Switch
            label="Show in culling"
            tooltip="Show in culling"
            value={data.showInCulling}
            onChange={(val) => onChange('showInCulling', val)}
            data-testid="show-in-culling"
          />
        </div>
      </div>
    </TEDrawerSection>
  );
};

export default Properties;
